"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconBoxCheck = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var IconBoxCheck = function IconBoxCheck(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    d: "M20.5 2c.547 0 1.027.246 1.34.64l1.625 1.962c.336.394.535.898.535 1.484v14.582A2.331 2.331 0 0121.664 23H2.336A2.331 2.331 0 010 20.668V6.086c0-.586.2-1.09.535-1.484l1.61-1.961a1.732 1.732 0 011.351-.645zm-5.117 8.195l-4.887 4.903-1.879-1.883a1.09 1.09 0 00-1.547 0 1.106 1.106 0 000 1.555l2.653 2.66a1.088 1.088 0 001.547 0l5.66-5.68a1.101 1.101 0 000-1.55 1.09 1.09 0 00-1.547 0zm5.035-7.027H3.422l-.945 1.164h19.039l-1.094-1.164zm0 0"
  }));
};
exports.IconBoxCheck = IconBoxCheck;